
import axios from "axios";
// import { updateTradeStatus } from "../Utils/TradeData";
import US500 from "../assets/Coin/US500.svg";
import US100 from "../assets/Coin/US100.svg";
import UK100 from "../assets/Coin/UK100.svg";
import DXY from "../assets/Coin/DXY.svg";
import USOIL from "../assets/Coin/USOIL.svg";
import XAU from "../assets/Coin/XAU.svg";
import XAG from "../assets/Coin/XAG.svg";
import XNG from "../assets/Coin/XNG.svg";
const style = {
  tableData: "text-[12px] text-[#f2f2f2] font-poppins font-normal py-3 px-2 text-center",
};
const getSymbolIcon = (symbol) => {
  switch (symbol) {
    case "US500":
      return US500;
    case "US100":
      return US100;
    case "UK100":
      return UK100;
    case "DXY":
      return DXY;
    case "USOIL":
      return USOIL;
    case "XAU/USD":
      return XAU;
    case "XAG/USD":
      return XAG;
    case "XNG/USD":
      return XNG;
    default:
      return US500;
  }
}

const LiveTradeTable = ({ tradeData, fetchData }) => {
  const filteredArrays =
    tradeData && tradeData.filter((innerArray) => innerArray[7] === "Approved");
    const saved = localStorage.getItem("userDetails");
  const initialValue = JSON.parse(saved);
  const userDetails = initialValue && initialValue.response;

  const update = async (value, index, email) => {
    try {
      const response = await axios.post("https://server.anshfintech.com/api/common/live/update-trade", {
        row: index + 2, // Assuming the row index starts from 1
        value: value === "TRUE" ? "FALSE" : "TRUE",
        email: email,
        // email: "hrithiksingh157@gmail.com",
      });
      if (response.status === 200) {
        console.log("Update successful");
        fetchData();
        return response;
      }
    } catch (error) {
      console.error("Error updating trade:", error);
    }
  };

  // const update = (id, index, email) => {
  //   updateTradeStatus(id, index, email);
  // }

  return (
    <div className="mb-4 bg-gradient-to-tl from-[#FEF35A99]/90 via-[#FFFFFF]/20 to-[#FEF35A99]/10 p-[1px]  rounded-[12px] md:rounded-[26px] rounded-lg shadow-custom-inner-high backdrop-blur-custom bg-black h-full w-full">
      <div
        className={`flex flex-col h-full md:space-y-4 py-3 md:py-4 bg-gradient-to-b from-[#000000]/80 from-80% via-[#000000] via-80% to-[#000000] to-20%   rounded-[12px] md:rounded-[26px] py-4 text-white shadow-custom-inner-high backdrop-blur-custom bg-black px-[2px]`}
      >
        <div
          className={`px-4 md:px-8 flex flex-row items-center leading-5 text-sm text-[#ffffff] font-normal md:text-base lg:text-xl `}
        >
          <div className="bg-[#E43D3D] w-3 h-3 md:w-4 md:h-4 rounded-full mr-2"></div>
          Update Live Trade
        </div>
        {!filteredArrays && !filteredArrays ? (
          <div className=" mt-6 w-full h-full custom-scroll overflow-x-auto  ">
            <table className="  text-sm w-full relative  z-0">
              <thead className=" text-sm text-left  border-b-[1px] border-[#818CEE]/20 shadow-custom-inner backdrop-blur-custom bg-black ">
                <tr className="text-white ">
                  <th className="py-6 text-center px-2 text-[14px] font-medium">
                    SYMBOL
                  </th>
                  <th className="py-6 text-center px-2 text-[14px] font-medium">
                    PNL VALUE
                  </th>
                  <th className="py-6 text-center px-2 text-[14px] font-medium">
                    ACTION
                  </th>
                </tr>
              </thead>
            </table>
            <span className="w-full text-white text-2xl md:text-4xl flex flex-row justify-center py-16">
              No Live Trades
            </span>
          </div>
        ) : filteredArrays && filteredArrays.length === 0 ? (
          <div className=" mt-6 w-full h-full  lg:h-full custom-scroll overflow-x-auto   ">
            <table className="  text-sm w-full relative  z-0">
              <thead className=" text-sm text-left  border-b-[1px] border-[#818CEE]/20 shadow-custom-inner backdrop-blur-custom bg-black ">
                <tr className="text-white ">
                  <th className="py-6 text-center px-2 text-[14px] font-medium">
                    SYMBOL
                  </th>
                  <th className="py-6 text-center px-2 text-[14px] font-medium">
                    PNL VALUE
                  </th>
                  <th className="py-6 text-center px-2 text-[14px] font-medium">
                    ACTION
                  </th>
                </tr>
              </thead>
            </table>
            <span className="w-full text-white text-2xl md:text-4xl flex flex-row justify-center py-16">
              No Live Trades
            </span>
          </div>
        ) : (
          <div className=" mt-6 w-full h-full lg:h-full custom-scroll overflow-x-auto   ">
            <table className="  text-sm w-full relative  z-0">
              <thead className=" text-sm text-left  border-b-[1px] border-[#818CEE]/20 shadow-custom-inner backdrop-blur-custom bg-black ">
                <tr className="text-[#ffffff]/60 ">
                  <th className="py-6 text-center px-2 text-[14px] font-medium">
                    SYMBOL
                  </th>
                  <th className="py-6 text-center px-2 text-[14px] font-medium">
                    PNL VALUE
                  </th>
                  <th className="py-6 text-center px-2 text-[14px] font-medium">
                    ACTION
                  </th>
                </tr>
              </thead>
              <tbody className=" shadow-custom-inner backdrop-blur-custom bg-black ">
                {filteredArrays &&
                  filteredArrays.map((dataItem, i) => {
                    // const item = dataItem[5];
                    // const checkValue = Math.sign(item);
                    // const pnlPercenet =
                    //   dataItem[6] && dataItem[6].replace("%", "");
                    // const pnlPercenetValue = Math.sign(pnlPercenet);
                    return (
                      <tr
                        key={i}
                        className=" z-0 border-b border-[#818CEE]/20 shadow-custom-inner backdrop-blur-custom bg-black "
                      >
                        <td className={style.tableData}>
                          <div className="flex items-center justify-center gap-2">
                            <img src={getSymbolIcon(dataItem[1])} alt="US500" className="w-6 h-6" />
                            {dataItem[1]}
                          </div>
                          </td>
                        <td
                        className={`text-[12px] text-[#f2f2f2] font-poppins font-normal text-center py-3 px-2 
                      ${
                        parseFloat(dataItem[7]) > 0
                          ? `text-[#18b13f]`
                          : parseFloat(dataItem[7]) < 0
                          ? ` text-[#eb323f]`
                          : `text-[#f2f2f2]`
                      }
                      `}
                      >
                        {dataItem[5]}
                      </td>
                        <td className={style.tableData}>
                          <button className="text-blue-500" onClick={() => 
                            update(dataItem[10], i, userDetails[1])
                            }>
                            {dataItem[10] === "TRUE" ? "Hide" : "Show"}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default LiveTradeTable;
